import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { isResellerAdminCreateCartLinkPopup } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { addNotification } from 'swag-client-common/redux/snackbar/snackbar.actions';
import { INotificationType } from 'swag-common/interfaces/snackbar-notification-type.interface';
import { preBuiltCartSave } from 'swag-client-common/redux/cart/cart.actions';
import { preBuiltCartLinkSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { preBuiltCartUserEmailSelector } from 'swag-client-common/redux/user/user.selectors';
import { PreBuiltCartAction } from 'swag-common/constants/reseller.constants';
import { CreateResellerCartPopupComponent } from './create-reseller-prebuild-cart-popup';
const mapStateToProps = createStructuredSelector({
  open: isResellerAdminCreateCartLinkPopup,
  userEmail: preBuiltCartUserEmailSelector,
  cartLink: preBuiltCartLinkSelector
});
const mapDispatchToProps = dispatch => ({
  onConfirmClick: () => {
    dispatch(preBuiltCartSave({
      action: PreBuiltCartAction.Save
    }));
  },
  onCloseClick: () => {
    dispatch(hidePopup());
  },
  notifyAboutCopy: () => {
    dispatch(addNotification({
      message: 'Copied!',
      type: INotificationType.SUCCESS,
      key: Date.now()
    }));
  }
});
export const CreateResellerCartPopup = connect(mapStateToProps, mapDispatchToProps)(CreateResellerCartPopupComponent);